import BaseRepository from './BaseRepository';

class UserRepository extends BaseRepository {
    /**
     * Register a user on the system
     *
     * @param {Object} data
     *
     * @returns {Promise}
     */
    register(data = {}) {
        return super.post('register', data);
    }

    /**
     * Updates the user
     *
     * @param {Object} data
     * @param {Vue} context
     *
     * @returns {Promise}
     */
    update(data = {}, context = null) {
        return super.put('me', data).then((response) => {
            if (context) {
                ['first_name', 'last_name', 'mobile', 'email'].forEach((detail) => {
                    context.$set(context.$root.user, detail, context[detail]);
                });
            }

            return response;
        });
    }

    /**
     * Patches the user
     *
     * @param {Object} data
     *
     * @returns {Promise}
     */
    patch(data = {}) {
        return super.patch('me', data);
    }

    /**
     * Fetch a users saved cards
     *
     * @param {string} token
     * @param {Object} data
     *
     * @returns {Promise}
     */
    getCards(data = {}, token) {
        return super.get(`cards?g_recaptcha_version=3&g_recaptcha_response=${token}`, data)
            .then(this.normaliseResponse);
    }

    /**
     * Adda single card to a user
     *
     * @param {Object} data
     *
     * @returns {Promise}
     */
    addCard(data = {}) {
        return super.post('cards', data);
    }
}

export default new UserRepository();
